// extracted by mini-css-extract-plugin
module.exports = {"container":"ReadMoreButton_container__a3wAp","text":"ReadMoreButton_text__9GwD3","arrow":"ReadMoreButton_arrow__cmPZ_"};